import { useSearchParams } from 'react-router';

import { PageHeader } from '@sorare/core/src/components/navigation/PageHeader';
import { ANY_SPORT_MARKET_MANAGER_SALES } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { navLabels } from '@sorare/core/src/lib/glossary';

export const MarketHeader = () => {
  const [searchParams] = useSearchParams();
  const previousParams = searchParams.get('previousParams');

  const { generateSportContextPath } = useSportContext();
  const marketBaseUrl = generateSportContextPath(
    ANY_SPORT_MARKET_MANAGER_SALES
  );
  const marketUrl =
    previousParams === null
      ? undefined
      : `${marketBaseUrl}${previousParams || ''}`;

  return (
    <PageHeader
      text={marketUrl ? undefined : navLabels.market}
      backTo={marketUrl}
      disableBackBrowser
    />
  );
};
